export enum TypePays {
  // Nouveaux
  FRANCE = "FRANCE",
  DROM_COM = "DROM_COM",
  MAYOTTE_GUYANNE = "MAYOTTE_GUYANNE",
  UE = "UE",
  HORS_UE = "HORS_UE",
  // Deprecated
  // D = "D",
  F = "F",
  // E = "E",
}
